import {GridColumns, GridValueGetterParams} from '@mui/x-data-grid';
import {FormattedMessage} from 'react-intl';
import {ConnectorStatusPill} from 'src/components/chargers/ConnectorStatusPill';
import {PopoverTypography} from 'src/components/common/PopoverTypography';
import {StatusField} from 'src/components/common/StatusField';
import {TableIdCell} from 'src/components/common/TableIdCell';
import {ChargerSortFieldEnum} from 'src/enums';
import {AppRouteEnum, AppRouteSpace} from 'src/utils/helper';
import {DeleteCharger} from '../DeleteCharger';
import dayjs from 'dayjs';

export const columnConfigChargers = (
    canRemove = true,
    isCompanyUser = false
): GridColumns => [
    {
        field: 'chargePointId',
        renderHeader: (_params) => <FormattedMessage id={'chargePointIdColumnHeader'}/>,
        flex: 2,
        minWidth: 150,
        sortable: false,
        cellClassName: 'ampTableCell',
        renderCell: (params) => {
            return (
                <TableIdCell
                    businessId={params.row.business.id}
                    label={params.row.chargePointId}
                    link={AppRouteSpace([AppRouteEnum.app, AppRouteEnum.chargers, params.row.id])}
                />
            );
        },
    },
    {
        field: 'name',
        renderHeader: (_params) => <FormattedMessage id={'chargePointNameColumnHeader'}/>,
        flex: 2,
        minWidth: 150,
        sortable: false,
        cellClassName: 'ampTableCell',
        renderCell: (params) => (
            <PopoverTypography
                popoverText={params.row.name}
                text={params.row.name}
            />
        ),
    },
    {
        field: ChargerSortFieldEnum.CHARGE_POINT_STATUS,
        renderHeader: (_params) => <FormattedMessage id={'stationStatusColumnHeader'}/>,
        flex: 3,
        minWidth: 100,
        cellClassName: 'ampTableCell',
        renderCell: (params) => {
            return <StatusField label={params.row.currentStatus}/>;
        },
    },
    {
        field: ChargerSortFieldEnum.CONNECTOR_POINT_STATUS,
        renderHeader: (_params) => <FormattedMessage id={'connectorStatusColumnHeader'}/>,
        flex: 3,
        minWidth: 180,
        cellClassName: 'ampTableCell',
        renderCell: (params) => <ConnectorStatusPill connectors={params.row.connectors}/>,
    },
    {
        field: ChargerSortFieldEnum.LOCATION_ID,
        renderHeader: (_params) => <FormattedMessage id={'locationNameColumnHeader'}/>,
        flex: 4,
        minWidth: 160,
        cellClassName: 'ampTableCell',
        renderCell: (params) => (
            <PopoverTypography
                popoverText={params.row.location?.name}
                text={params.row.location?.name}
            />
        ),
    },

    {
        field: 'client',
        renderHeader: (_params) => <FormattedMessage id={'clientColumnHeader'}/>,
        flex: 3,
        minWidth: 150,
        cellClassName: 'ampTableCell',
        sortable: false,
        valueGetter: (params) => {
            if (params.row.company?.name) {
                return params.row.company.name;
            }
            return params.row.user ? `${params.row.user.firstName} ${params.row.user.lastName}` : '';
        },
    },

    {
        field: ChargerSortFieldEnum.CREATED_AT,
        renderHeader: (_params) => <FormattedMessage id={'createdOnColumnHeader'}/>,
        flex: 3,
        minWidth: 150,
        cellClassName: 'ampTableCell',
        sortable: true,
        valueGetter: (params) =>
            params.row.createdAt ? dayjs(params.row.createdAt).format('DD/MM/YY') : '-',
    },
    ...(canRemove
        ? [
            {
                field: 'delete',
                headerName: '',
                width: 120,
                sortable: false,
                cellClassName: 'ampTableCell',
                align: 'right' as const,
                headerAlign: 'right' as const,
                renderCell: (params: GridValueGetterParams) => {
                    return (
                        <DeleteCharger
                            row={params.row}
                            isCompanyUser={isCompanyUser}
                        />
                    );
                },
            },
        ]
        : []),
];
